export default __webpack_public_path__ + "static/media/oee.d08c081b.webp";